export default "__VITE_ASSET__IwUpneIe__"